enum LOG_LEVELS {
  OFF,
  ERROR,
  WARN,
  INFO,
  DEBUG,
  TRACE,
}

export default LOG_LEVELS;
